import React from "react";
import get from "lodash/get";
import GeneralSectionPage from "./general-seciton-page";
import NlSenaWrapper from "./nl-sena-wrapper";
import { PodcastCollection } from "../pages/podcast-collection-page";
import { PodcastPage } from "../pages/podcast-page";
import VideosSectionPage from "./videos-section-page";
import VideosSubSectionPage from "./videos-sub-section-page";
import ComicsSectioPage from "./comics-section-page";
import { NLLegalFundPage } from "./nl-legal-fund-page";

const SectionPage = props => {
  const secitonSlug = get(props, ["data", "collection", "slug"], "");
  let sectionTemplate = get(props, ["data", "collection", "template"], "");

  if (secitonSlug === "sena") {
    sectionTemplate = "sena";
  } else if (secitonSlug === "nl-legal-fund") {
    sectionTemplate = "nl-legal-fund";
  }

  switch (sectionTemplate) {
    case "videossection":
      return <VideosSectionPage {...props} />;
    case "videossubsection":
      return <VideosSubSectionPage {...props} />;
    case "sena":
      return <NlSenaWrapper {...props} />;
    case "comicsection":
      return <ComicsSectioPage {...props} />;
    case "podcastsubsection":
      return <PodcastCollection {...props} />;
    case "podcast":
      return <PodcastPage {...props} />;
    case "nl-legal-fund":
      return <NLLegalFundPage {...props} />;
    default:
      return <GeneralSectionPage {...props} />;
  }
};

export { SectionPage };
